import { render, staticRenderFns } from "./NewCaseButton.vue?vue&type=template&id=60ff739b&scoped=true&"
import script from "./NewCaseButton.vue?vue&type=script&lang=js&"
export * from "./NewCaseButton.vue?vue&type=script&lang=js&"
import style0 from "./NewCaseButton.vue?vue&type=style&index=0&id=60ff739b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff739b",
  null
  
)

export default component.exports